module.exports = __webpack_public_path__ + "img/file-regular-full.6e437afa.svg";